<script lang="ts" setup>
import type { TranslatableString } from '~/types/widgets/widgetTypes'

interface Props {
  banners?: {
    slug: TranslatableString
    mobile: TranslatableString
    desktop: TranslatableString
    openLinksInNewTab?: boolean
  }[]
}

const props = defineProps<Props>()
</script>

<template>
  <div v-if="Boolean(props.banners?.length)" class="banner-slider">
    <ClientOnly>
      <BannerSliderContent :banners="props.banners" />
    </ClientOnly>
  </div>
</template>

<style lang="postcss">
.banner-slider {
  @apply p-4 m-auto max-w-xlg;
}
</style>
